/* LGND Product Story — interactions for lgnd-story-* sections. Safe to load more than once. */
(function () {
  if (window.__lgndStory) return;
  window.__lgndStory = true;
  document.documentElement.classList.add('ls-js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function mainSection() {
    var picker = document.querySelector('variant-picker[context="main_product"]');
    return (picker && picker.closest('.shopify-section')) || document.querySelector('.shopify-section[id$="__main"]');
  }
  function scrollToEl(el) {
    if (!el) return;
    var header = document.querySelector('.shopify-section--header, header');
    var offset = header ? Math.min(header.getBoundingClientRect().height, 120) : 0;
    var y = el.getBoundingClientRect().top + window.pageYOffset - offset - 8;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }

  function init() {
    /* Reveal */
    var reveals = document.querySelectorAll('[data-ls-reveal]');
    if (hasIO && !reduce) {
      var rio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px' });
      reveals.forEach(function (el) { rio.observe(el); });
    } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }

    /* Videos play only while on screen */
    var vids = document.querySelectorAll('video[data-ls-autoplay]');
    if (!reduce && hasIO) {
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && v.offsetParent !== null) {
            if (v.preload === 'none') v.preload = 'auto';
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) { v.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { vio.observe(v); });
    }

    /* Scroll links */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ls-scroll]');
      if (!a) return;
      var t = a.getAttribute('data-ls-scroll');
      var el = t === 'buy' ? mainSection() : document.getElementById(t);
      if (!el && t !== 'buy') el = mainSection();
      if (el) { e.preventDefault(); scrollToEl(el); }
    });

    /* Features: sticky media follows active step */
    document.querySelectorAll('[data-ls-features]').forEach(function (root) {
      var steps = root.querySelectorAll('.ls-step');
      var panels = root.querySelectorAll('.ls-feat__panel');
      var ticks = root.querySelectorAll('.ls-feat__count span');
      function setActive(i) {
        steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        panels.forEach(function (p, n) {
          p.classList.toggle('is-active', n === i);
          var v = p.querySelector('video');
          if (v && !reduce) { if (n === i) { v.preload = 'auto'; var pr = v.play(); if (pr && pr.catch) pr.catch(function(){}); } else v.pause(); }
        });
        ticks.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      }
      setActive(0);
      if (!hasIO) return;
      var fio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) setActive(Array.prototype.indexOf.call(steps, e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { fio.observe(s); });
    });

    /* Builds: select a variant in the main buy box */
    var buildRoots = document.querySelectorAll('[data-ls-builds]');
    function mainInputs() {
      return document.querySelectorAll('variant-picker[context="main_product"] input[type="radio"]');
    }
    function syncBuilds() {
      var checked = Array.prototype.filter.call(mainInputs(), function (i) { return i.checked; })[0];
      buildRoots.forEach(function (root) {
        root.querySelectorAll('.ls-build').forEach(function (card) {
          var on = checked && card.getAttribute('data-ls-value') === checked.value;
          card.classList.toggle('is-selected', !!on);
          var btn = card.querySelector('[data-ls-select]');
          if (btn) btn.querySelector('.ls-btn__label').textContent = on ? btn.getAttribute('data-on') : btn.getAttribute('data-off');
        });
      });
    }
    if (buildRoots.length) {
      document.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ls-select]');
        if (!b) return;
        e.preventDefault();
        var val = b.getAttribute('data-ls-select');
        var input = Array.prototype.filter.call(mainInputs(), function (i) { return i.value === val; })[0];
        if (input && !input.checked) input.click();
        setTimeout(syncBuilds, 50);
        scrollToEl(mainSection());
      });
      document.addEventListener('change', function (e) {
        if (e.target.closest && e.target.closest('variant-picker[context="main_product"]')) setTimeout(syncBuilds, 30);
      });
      syncBuilds();
    }

    /* Gallery rail: arrows + progress */
    document.querySelectorAll('[data-ls-rail]').forEach(function (root) {
      var rail = root.querySelector('.ls-rail');
      var prev = root.querySelector('[data-ls-prev]');
      var next = root.querySelector('[data-ls-next]');
      var bar = root.querySelector('.ls-rail__bar span');
      function step() { var it = rail.querySelector('.ls-rail__item'); return it ? it.getBoundingClientRect().width + 20 : 300; }
      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        var p = max > 0 ? rail.scrollLeft / max : 0;
        var vis = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
        if (bar) { bar.style.width = (vis * 100) + '%'; bar.style.transform = 'translateX(' + (p * (1 / vis - 1) * 100) + '%)'; }
        if (prev) prev.disabled = rail.scrollLeft <= 4;
        if (next) next.disabled = rail.scrollLeft >= max - 4;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
